import { Link } from "react-router-dom";

const LEFT_IMG = "/gallery/owner-4.jpg";
const RIGHT_IMG = "/gallery/work-2.jpg";

export const SplitCTA = () => (
  <section data-testid="split-cta-section" className="grid grid-cols-1 md:grid-cols-2">
    <div className="relative px-6 sm:px-12 py-20 md:py-32 text-center flex flex-col items-center justify-center overflow-hidden">
      <img src={LEFT_IMG} alt="Gray Corvette with a deep-gloss finish after detail" className="absolute inset-0 w-full h-full object-cover" />
      <div className="absolute inset-0 bg-[#0A0A0C]/60" />
      <div className="relative">
        <p className="font-display uppercase text-xs font-medium tracking-[0.3em] text-white/85">
          Which wash is the best for your vehicle?
        </p>
        <h2 className="mt-4 font-display uppercase font-semibold text-3xl sm:text-4xl lg:text-5xl tracking-wide text-white">
          Wash Packages
        </h2>
        <Link
          to="/packages"
          data-testid="split-cta-packages-button"
          className="mt-7 inline-block bg-white text-[#0A0A0C] font-display uppercase font-medium tracking-[0.12em] text-xs px-10 py-4 hover:bg-[#EA0A0B] hover:text-white transition-colors"
        >
          View Our Package Plans
        </Link>
      </div>
    </div>

    <div className="relative px-6 sm:px-12 py-20 md:py-32 text-center flex flex-col items-center justify-center overflow-hidden">
      <img src={RIGHT_IMG} alt="Black SUV with wet-look gloss after detail" className="absolute inset-0 w-full h-full object-cover" />
      <div className="absolute inset-0 bg-[#0A0A0C]/60" />
      <div className="relative">
        <h2 className="font-display uppercase font-semibold text-3xl sm:text-4xl lg:text-5xl tracking-wide text-white leading-tight max-w-xl">
          Voted the best auto detail expert in Charlotte, NC and surroundings
        </h2>
        <Link
          to="/contact-us"
          data-testid="split-cta-contact-button"
          className="mt-7 inline-block border border-white/70 hover:border-[#FF4311] hover:text-[#FF4311] text-white font-display uppercase font-medium tracking-[0.12em] text-xs px-10 py-4 transition-colors"
        >
          Contact Us
        </Link>
      </div>
    </div>
  </section>
);
